var _circle, _g, _circle2, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    fill: "#6FCBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_32215_272)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 46,
    fill: "url(#paint0_linear_32215_272)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 45.5,
    stroke: "#52B3E9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_32215_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2266 67C67.9531 67 67.7578 66.9453 67.6406 66.8359C67.5234 66.7266 67.4648 66.5039 67.4648 66.168V51.4961C67.4648 51.1602 67.5195 50.9375 67.6289 50.8281C67.7461 50.7109 67.9727 50.6523 68.3086 50.6523H70.5234C70.6953 50.6523 70.8398 50.6602 70.957 50.6758C71.0742 50.6836 71.1797 50.707 71.2734 50.7461C71.3672 50.7852 71.457 50.8438 71.543 50.9219C71.6289 51 71.7266 51.1055 71.8359 51.2383C72.0859 51.5586 72.3711 51.9844 72.6914 52.5156C73.0195 53.0391 73.3633 53.6211 73.7227 54.2617C74.0898 54.8945 74.4688 55.5625 74.8594 56.2656C75.25 56.9609 75.6406 57.6406 76.0312 58.3047C76.4219 58.9688 76.8008 59.5898 77.168 60.168C77.543 60.7461 77.8945 61.2344 78.2227 61.6328H78.3516L78.2812 51.4961C78.2812 51.1602 78.3359 50.9375 78.4453 50.8281C78.5547 50.7109 78.7617 50.6523 79.0664 50.6523H81.0234C81.3203 50.6523 81.5273 50.7109 81.6445 50.8281C81.7617 50.9375 81.8203 51.1602 81.8203 51.4961V66.168C81.8203 66.332 81.8086 66.4688 81.7852 66.5781C81.7617 66.6875 81.7188 66.7734 81.6562 66.8359C81.6016 66.8984 81.5195 66.9414 81.4102 66.9648C81.3008 66.9883 81.1641 67 81 67H78.75C78.6094 67 78.4844 66.9922 78.375 66.9766C78.2734 66.9609 78.1758 66.9297 78.082 66.8828C77.9883 66.8359 77.8945 66.7734 77.8008 66.6953C77.7148 66.6172 77.6172 66.5156 77.5078 66.3906C77.2109 66.0156 76.8906 65.5625 76.5469 65.0312C76.2031 64.4922 75.8477 63.9141 75.4805 63.2969C75.1211 62.6719 74.75 62.0312 74.3672 61.375C73.9844 60.7109 73.6055 60.0664 73.2305 59.4414C72.8555 58.8086 72.4844 58.2188 72.1172 57.6719C71.7578 57.1172 71.4141 56.6406 71.0859 56.2422H70.957L70.9922 66.168C70.9922 66.5039 70.9375 66.7266 70.8281 66.8359C70.7188 66.9453 70.4961 67 70.1602 67H68.2266Z",
    fill: "#005587"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_32215_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9375 67C60.6016 67 60.3789 66.9453 60.2695 66.8359C60.1602 66.7266 60.1055 66.5039 60.1055 66.168V51.4961C60.1055 51.1602 60.1602 50.9375 60.2695 50.8281C60.3789 50.7109 60.6016 50.6523 60.9375 50.6523H62.8359C63 50.6523 63.1328 50.6641 63.2344 50.6875C63.3438 50.7109 63.4258 50.7578 63.4805 50.8281C63.543 50.8906 63.5859 50.9766 63.6094 51.0859C63.6328 51.1953 63.6445 51.332 63.6445 51.4961V66.168C63.6445 66.332 63.6328 66.4688 63.6094 66.5781C63.5859 66.6875 63.543 66.7734 63.4805 66.8359C63.4258 66.8984 63.3438 66.9414 63.2344 66.9648C63.1328 66.9883 63 67 62.8359 67H60.9375Z",
    fill: "#005587"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_32215_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1953 67C45.8984 67 45.6953 66.9453 45.5859 66.8359C45.4844 66.7266 45.4336 66.5039 45.4336 66.168V51.4961C45.4336 51.1602 45.4883 50.9375 45.5977 50.8281C45.707 50.7188 45.9297 50.6641 46.2656 50.6641H51.3633C52.3242 50.6641 53.1836 50.7812 53.9414 51.0156C54.6992 51.2422 55.3398 51.582 55.8633 52.0352C56.3945 52.4883 56.8008 53.0547 57.082 53.7344C57.3633 54.4141 57.5039 55.2031 57.5039 56.1016C57.5039 57.1172 57.3398 57.9922 57.0117 58.7266C56.6836 59.4609 56.2305 60.0664 55.6523 60.543C55.082 61.0117 54.4102 61.3594 53.6367 61.5859C52.8711 61.8125 52.0469 61.9258 51.1641 61.9258H48.9844V66.168C48.9844 66.332 48.9727 66.4688 48.9492 66.5781C48.9258 66.6875 48.8828 66.7734 48.8203 66.8359C48.7578 66.8984 48.6719 66.9414 48.5625 66.9648C48.4531 66.9883 48.3125 67 48.1406 67H46.1953ZM48.9844 59.207H51.1055C51.5352 59.207 51.9297 59.1484 52.2891 59.0312C52.6562 58.9062 52.9688 58.7227 53.2266 58.4805C53.4922 58.2383 53.6953 57.9375 53.8359 57.5781C53.9844 57.2188 54.0586 56.7969 54.0586 56.3125C54.0586 55.7734 53.9766 55.3242 53.8125 54.9648C53.6562 54.5977 53.4414 54.3047 53.168 54.0859C52.8945 53.8594 52.5703 53.6992 52.1953 53.6055C51.8281 53.5039 51.4336 53.4531 51.0117 53.4531H48.9844V59.207Z",
    fill: "#005587"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_32215_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5235 63.8125C31.6251 63.5625 31.754 63.4102 31.9103 63.3555C32.0665 63.3008 32.3048 63.3398 32.6251 63.4727C32.9923 63.6289 33.336 63.7617 33.6563 63.8711C33.9767 63.9805 34.2892 64.0703 34.5938 64.1406C34.8985 64.2109 35.2071 64.2656 35.5196 64.3047C35.8321 64.3359 36.1642 64.3516 36.5157 64.3516C36.961 64.3516 37.3478 64.3047 37.6759 64.2109C38.004 64.1094 38.2735 63.9727 38.4845 63.8008C38.7032 63.6211 38.8634 63.4141 38.9649 63.1797C39.0743 62.9375 39.129 62.6758 39.129 62.3945C39.129 61.832 38.8946 61.375 38.4259 61.0234C37.9649 60.6719 37.2579 60.3594 36.3048 60.0859C35.5235 59.875 34.8126 59.6484 34.172 59.4062C33.5392 59.1562 32.9962 58.8555 32.5431 58.5039C32.0978 58.1445 31.754 57.7109 31.5118 57.2031C31.2696 56.6953 31.1485 56.0742 31.1485 55.3398C31.1485 54.582 31.2696 53.8984 31.5118 53.2891C31.7618 52.6719 32.1368 52.1523 32.6368 51.7305C33.1368 51.3008 33.7579 50.9727 34.5001 50.7461C35.2501 50.5117 36.129 50.3945 37.1368 50.3945C37.5353 50.3945 37.9415 50.4258 38.3556 50.4883C38.7774 50.543 39.1876 50.6211 39.586 50.7227C39.9845 50.8164 40.3634 50.9258 40.7228 51.0508C41.0899 51.1758 41.4142 51.3047 41.6954 51.4375C41.8438 51.5078 41.9532 51.5781 42.0235 51.6484C42.1017 51.7188 42.1485 51.793 42.1642 51.8711C42.1876 51.9492 42.1876 52.0352 42.1642 52.1289C42.1407 52.2227 42.1017 52.3281 42.047 52.4453L41.5899 53.5352C41.5274 53.6523 41.4649 53.75 41.4024 53.8281C41.3478 53.9062 41.2813 53.9609 41.2032 53.9922C41.1251 54.0156 41.0353 54.0234 40.9337 54.0156C40.8321 54 40.7071 53.9609 40.5587 53.8984C40.1993 53.7422 39.7462 53.6055 39.1993 53.4883C38.6603 53.3633 38.0782 53.3008 37.4532 53.3008C36.5548 53.3008 35.8673 53.4531 35.3907 53.7578C34.9142 54.0625 34.6759 54.4883 34.6759 55.0352C34.6759 55.3555 34.7345 55.625 34.8517 55.8438C34.9767 56.0625 35.1642 56.2539 35.4142 56.418C35.6642 56.582 35.9845 56.7344 36.3751 56.875C36.7735 57.0156 37.2501 57.168 37.8048 57.332C38.5548 57.5352 39.2306 57.7812 39.8321 58.0703C40.4337 58.3516 40.9415 58.6875 41.3556 59.0781C41.7696 59.4688 42.086 59.918 42.3048 60.4258C42.5313 60.9258 42.6446 61.4922 42.6446 62.125C42.6446 62.8984 42.5274 63.6016 42.2931 64.2344C42.0587 64.8672 41.6993 65.4062 41.2149 65.8516C40.7306 66.2969 40.1173 66.6406 39.3751 66.8828C38.6407 67.125 37.7696 67.2461 36.7618 67.2461C36.1524 67.2461 35.5899 67.2109 35.0743 67.1406C34.5665 67.0781 34.0938 66.9922 33.6563 66.8828C33.2267 66.7656 32.8282 66.6367 32.461 66.4961C32.0938 66.3477 31.754 66.1953 31.4415 66.0391C31.1524 65.9062 30.9845 65.7734 30.9376 65.6406C30.8907 65.5 30.922 65.3008 31.0313 65.043L31.5235 63.8125Z",
    fill: "#005587"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_32215_272",
    x: 11,
    y: 11,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.398145 0 0 0 0 0.783218 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32215_272"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_32215_272",
    x: 67.4648,
    y: 50.6523,
    width: 14.3555,
    height: 20.3477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32215_272"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_32215_272",
    x: 60.1055,
    y: 50.6523,
    width: 3.53906,
    height: 20.3477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32215_272"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_32215_272",
    x: 45.4336,
    y: 50.6641,
    width: 12.0703,
    height: 20.3359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32215_272"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_32215_272",
    x: 30.9165,
    y: 50.3945,
    width: 11.728,
    height: 20.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32215_272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32215_272",
    x1: 57,
    y1: 11,
    x2: 57,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2985B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinLight);
export default __webpack_public_path__ + "static/media/spin_light.8daa9a72fe69284315a2b924306a6b57.svg";
export { ForwardRef as ReactComponent };